document.addEventListener("latte:init", init);
function init () {
	$('.remodal').each(function () {
		var remodalId = $(this).attr('data-remodal-id');
		$('[data-remodal-id=' + remodalId + ']').remodal();
	});

	$(document).on('click', '.remodal-wrapper a', function () {
		var remodalId = $(this).closest('.remodal').attr('data-remodal-id');
		var inst = $('[data-remodal-id=' + remodalId + ']').remodal();
		$('html').removeClass('remodal-is-locked');
		$('.remodal-overlay').removeClass('remodal-is-opened').addClass('remodal-is-closed').css({ "display": "none" });
		if (inst) {
			inst.close();
		}
	});
}


//////////////////
// WEBPACK FOOTER
// ./public/js/modals.js
// module id = 80
// module chunks = 0